import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useWidgetData } from '../../hooks/useWidgetData';

/**
 * Claim Widget Component
 * Modernized - Displays claim counts (Total, Reversed, Net, Paid)
 */
function Claim({ data }) {
    // Use the same useWidgetData hook as all other widgets
    const { data: apiData, loading } = useWidgetData(
        data?.url,
        data?.RequestJson,
        data?.RequestJson1
    );

    // Derive claim values from API response; legend[0]=Total, [1]=Reversed, [2]=Net, [3]=Paid
    const claims = React.useMemo(() => {
        if (!apiData || apiData.length === 0 || !apiData[0].legend) {
            return { total: '0', reversed: '0', net: '0', paid: '0' };
        }
        return {
            total: apiData[0].legend[0]?.legendValue ?? '0',
            reversed: apiData[0].legend[1]?.legendValue ?? '0',
            net: apiData[0].legend[2]?.legendValue ?? '0',
            paid: apiData[0].legend[3]?.legendValue ?? '0'
        };
    }, [apiData]);

    const statCards = [
        { label: 'Total Claims',    value: claims.total },
        { label: 'Reversed Claims', value: claims.reversed },
        { label: 'Net Claims',      value: claims.net },
        { label: 'Paid Claims',     value: claims.paid },
    ];

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {statCards.map(({ label, value }) => (
                <div key={label} className="relative bg-card rounded-lg p-6 shadow-sm border border-border">
                    {loading && (
                        <Loader2 className="absolute top-3 right-3 h-8 w-8 animate-spin text-accent" />
                    )}
                    <p className="text-md font-medium text-muted-foreground">{label}</p>
                    <p className="text-3xl font-bold text-primary mt-1">
                        {loading ? <span className="text-muted-foreground/40">—</span> : value}
                    </p>
                </div>
            ))}
        </div>
    );
}

export default Claim;
